'use strict';

var compareWidget = require('../compare-widget'),
	backtotop = require('../backtotop.js'),
	productTile = require('../product-tile'),
	progress = require('../progress'),
	util = require('../util'),
	googletaglinchpin = require('int_googletagmanager/googletaglinchpin'),
	linchpin = require('int_googletagmanager/linchpin/search'),
	refinementsSlider = require('./refinementsslider'),
	lazyloading = require('../lazyloading'),
	hampers = require('int_googletagmanager/linchpin/hampers'),
	wishlist = require('./wishlist');

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing (query, pop, callback) {
	var refineUrl;

	if (typeof window.history.pushState === 'function' && typeof query === 'string') {
		if (query && ! pop) {
			refineUrl = window.location.pathname + '?' + query;
			window.history.pushState(query, $(document).find('title').text(), refineUrl);
		} else if (query && pop) {
			refineUrl = window.location.pathname + '?' + query;
		} else if ((query === '') && pop) {
			refineUrl = window.location.href.split('?')[0];
			window.history.pushState(query, $(document).find('title').text(), window.location.pathname);
		} else {
			refineUrl = window.location.pathname;
		}
	} else {
		var hash = location.href.split('#')[1];
		if (hash === 'results-content' || hash === 'results-products') { return; }

		if (typeof hash !== 'undefined' && hash.length > 0) {
			refineUrl = window.location.pathname + '?' + hash;
		} else {
			refineUrl = window.location.pathname;
		}
	}
	//default is always true, unless explicitly changed by user;
	var isGridView = $('.toggle-grid .grid-view').length > 0 ? $('.toggle-grid .grid-view').hasClass('active') : true;

	progress.show($('.search-result-content'));

	var replace = '#main';
	if ($('.search-load-in-primary').length > 0) {
		replace = '#primary';
	}

	$(replace).load(util.appendParamToURL(refineUrl, 'format', 'ajax'), function () {
		compareWidget.init();
		productTile.gridViewToggle(isGridView);
		productTile.init();
		refinementsSlider();
		progress.hide();
		lazyLoadInit();
		$('#main').find('select, input[type=radio],input[type=checkbox]').uniform();
		initHorizontalCarouselWrapper();
		wishlist.markWishlistProducts();
		if (typeof callback === 'function') {
			callback.call();
		}
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			// re-init namespace specific events
			if (window.pageContext.ns) {
				googletaglinchpin.init(window.pageContext.ns);
			}
		}
		if (SitePreferences.LAZYLOAD_ENABLED) {
			lazyloading.init($(replace));
		}
	});
}
/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents () {
	var $main = $('#main');
	// compare checked
	$main.on('click', 'input[type="checkbox"].compare-check', function () {
		var cb = $(this);
		var tile = cb.closest('.product-tile');

		var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
		var itemImg = tile.find('.product-image a img').first();
		func({
			itemid: tile.data('itemid'),
			uuid: tile[0].id,
			img: itemImg,
			cb: cb
		});

	});

	// handle toggle refinement blocks
	$main.on('click', '.refinement h3', function () {
		$(this).toggleClass('expanded');
	});

	// handle event for 'See more' link
	$main.on('click', '.see-more .expand', function () {
		$(this).parent('.see-more').addClass('expanded');
	});

	$main.on('touchstart click', '.refinement_filter', function (e) {
		var $refinements = $('.refinements .refinement').not('.reset');
		e.preventDefault();
		$(this).toggleClass('active');
		if ($(this).hasClass('active')) {
			$refinements.addClass('active').show();
		} else {
			$refinements.removeClass('active').hide();
		}
	});

	// handle events for updating grid
	$main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function () {
		if ($(this).parent().hasClass('unselectable')) { return; }
		if ($(this).hasClass('disabled-ref')) {
			return false;
		} else if ($(this).hasClass('retrieve-gifts')) {
			return true;
		}
		var catparent = $(this).parents('.category-refinement');
		var folderparent = $(this).parents('.folder-refinement');
		var resetlink = $(this).hasClass('reset-filters');

		//if the anchor tag is underneath a div with the class names & , prevent the double encoding of the url
		//but also not a reset link
		//else handle the encoding for the url
		if ((catparent.length > 0 || folderparent.length > 0) && !resetlink) {
			return true;
		} else {
			var stringUrl = this.href;
			var inStockOnly = $('.refinement.instock a').hasClass('checked');

			// 'In stock' refinement clicked
			if ($(this).parents('.refinement').hasClass('instock')) {
				// toggle value
				inStockOnly = !inStockOnly;
			}
			if (resetlink) {
				inStockOnly = false;
			}
			// Add 'In Stock Only' search parameter
			stringUrl = util.appendParamToURL(stringUrl, 'inStockOnly', inStockOnly);

			var $filterElement = $(this);
			// Identify if the filter items and trigger linchpin actions
			var isFilterElement = !$filterElement.hasClass('display-all');
			var uri = util.getUri(stringUrl);
			if (uri.query.length > 1) {
				if (typeof window.history.pushState === 'function') {
					updateProductListing(uri.query.substring(1), false, function () {
						// Callback function to call after applying filters
						if (SitePreferences.GTM_ENABLED && isFilterElement) {
							if ($('input[name=searchPhrase]').length > 0) {
								if (window.location.search.indexOf('&') === -1) {
									linchpin.triggerSearchClearFilters();
								} else {
									linchpin.triggerSearchFilterEvent($filterElement);
								}
							} else {
								linchpin.triggerCategoryFilterEvent($filterElement);
							}
						}
					});
				} else {
					window.location.hash = uri.query.substring(1);
				}
			} else {
				if (typeof window.history.pushState === 'function') {
					updateProductListing('', true);
				} else {
					window.location.href = this.href;
				}
			}
			return false;
		}
	});

	// handle events for updating grid from search
	$main.on('click', '#hamper-refinement-search button', function (e) {
		e.preventDefault();
		var $form = $(this).closest('form');
		var $query = $form.find('input[name="q"]');
		var uri = util.getUri($form.attr('action'));
		var url = uri.query.substring(1) + '&q=' + $query.val();
		// GTM linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			hampers.hamperSearchEvent(e, $query);
		}
		if (typeof window.history.pushState === 'function') {
			updateProductListing(url);
		} else {
			window.location.hash = url;
		}
		return false;
	});

	// handle events for updating grid to view hamper items
	$main.on('click', '.mobile-view-items', function (e) {
		e.preventDefault();
		var url = this.href;

		window.history.pushState(url, $(document).find('title').text(), url);

		progress.show($('.search-result-content'));
		$('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
			compareWidget.init();
			productTile.init();
			refinementsSlider();
			progress.hide();
			lazyLoadInit();
			$('#main').find('select, input[type=radio],input[type=checkbox]').uniform();
			initHorizontalCarouselWrapper();
		});
	});
	//handle UI hide/show for refinements
	$main.on('click', 'h3.toggle-refinement', function () {
		$(this).toggleClass('expanded').closest('.refinement').toggleClass('active');
	});
	$main.on('click', '.refinement-link', function () {
		if (!$(this).hasClass('disabled-ref')) {
			$(this).toggleClass('checked');
		}
	});
	//navigate to content search results if exists
	$main.on('click', '.other-suggestion-link', function () {
		var pos = $('#other-suggestions').offset().top;
		window.scrollTo(0, pos);
	});

	// handle events item click. append params to url
	$main.on('click', '.product-tile a:not(".quickviewbutton, .read-more-promo-link, .add-to-wishlist, .remove-from-wishlist")', function (e) {
		e.preventDefault();
		var url = this.href;
		var isAlgoliaEnabled = window.algoliaData && window.algoliaData.enable && window.algoliaData.enablePLP;
		var $searchResults = isAlgoliaEnabled ? $('#algolia-hits-placeholder') : $('#search-result-items');
		var cgid = $searchResults.data('cgid');
		if (cgid) {
			url = util.appendParamsToUrl(url, {'cgid': cgid});
		}
		window.location.href = url;
	});

	// handle events item click. append params.
	$main.on('click', '.product-tile a:not(".quickviewbutton, .read-more-promo-link")', function () {
		var a = $(this);
		// get current page refinement values
		var wl = window.location;

		var qsParams = (wl.search.length > 1) ? util.getQueryStringParams(wl.search.substr(1)) : {};
		var hashParams = (wl.hash.length > 1) ? util.getQueryStringParams(wl.hash.substr(1)) : {};

		// merge hash params with querystring params
		var params = $.extend(hashParams, qsParams);
		if (!params.start) {
			params.start = 0;
		}
		// get the index of the selected item and save as start parameter
		var tile = a.closest('.product-tile');
		var idx = tile.data('idx') ? + tile.data('idx') : 0;

		// convert params.start to integer and add index
		params.start = (+params.start) + (idx + 1);
		// set the hash and allow normal action to continue
		a[0].hash = $.param(params);
	});

	// handle sorting change
	$main.on('change', '.sort-by select', function () {
		var refineUrl = $(this).find('option:selected').val();
		var uri = util.getUri(refineUrl);

		if (typeof window.history.pushState === 'function') {
			updateProductListing(uri.query.substring(1));
		} else {
			window.location.hash = uri.query.substring(1);
		}

		return false;
	})
	.on('change', '.items-per-page select', function () {
		var refineUrl = $(this).find('option:selected').val();
		if (refineUrl === 'INFINITE_SCROLL') {
			$('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
		} else {
			$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
			var uri = util.getUri(refineUrl);

			if (typeof window.history.pushState === 'function') {
				updateProductListing(uri.query.substring(1));
			} else {
				window.location.hash = uri.query.substring(1);
			}
		}
		return false;
	});

	$('.load-more-link a').on('click', function () {
		// GTM linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.triggerSearchLoadMore();
		}
	});

	$(document).ready(function () {
		var url = window.location.href;
		$('.main-navigation a[href="' + url + '"]').addClass('current');
		$('.main-navigation a[href="' + url + '"]').closest('.sub-level-item').addClass('current');
		$('.main-navigation a[href="' + url + '"]').closest('.top-level').addClass('current');
	});

	// Detect when a user clicks the back button after the pushState function has been called
	if (document.readyState !== 'complete') {
		$(window).on('load', function () {
			setTimeout(function () {
				window.addEventListener('popstate', function (event) {
					updateProductListing(event.state, true);
				});
			}, 0);
		});
	} else {
		window.addEventListener('popstate', function (event) {
			updateProductListing(event.state, true);
		});
	}

	// handle hash change
	window.onhashchange = updateProductListing;
}
/*
 * @param {DOM Element} link A lazy load link either of product or content search results
 * @description assign event handler for lazy load link(s) either for both (content and product) search results or
 * for specific link (mostly for a new link that appears as a result of successful ajax call)
 */
function lazyLoadInit (link) {
	var $lazyLoadLinks = link || $('.load-more-link a');

	if ($lazyLoadLinks.length) {
		$lazyLoadLinks.on('click', function (e) {
			if ($(this).hasClass('inactive')) {
				return false;
			}
			e.preventDefault();
			lazyLoadLinkHandler($(this));
			$(this).addClass('inactive');
		});
	}
	loadBackToPageResult();
}
/*
 * @description click event handler for lazy load link. It prepares data for ajax call and callback based on a link being clicked
 * Invoke doLazyLoad passing retrieved data as params
 */
function lazyLoadLinkHandler ($clickedLink) {
	var $grid, $link, url;

	$grid = $clickedLink.closest('.search-result-content');
	$link = $clickedLink.parent();
	url = $clickedLink.attr('href');

	//update grid if it's a content search results and not a product search results
	$grid = $grid.length ? $grid : $clickedLink.closest('.search-results-content');
	doLazyLoad(url, $link, $grid);

}
/*
 * @param {URL} url URL to load next portion of results
 * @param link {DOM Element} link that contains URL
 * @param container {DOM Element} grid either product or content results
 *
 * @description perform AJAX call to get new products,
 * appends product(s) from result into proper grid, removes link used to load given portion,
 * get a new link from the result if exist and invoke lazyLoadInit passing it as param
 *
 */
function doLazyLoad (url, link, container) {

	$.ajax({
		url:url,
		method:'GET',
		dataType:'html'
	}).done(function (data) {
		link.remove();
		container.append(data);
		productTile.init();

		//if it's a product search results;
		if (container.hasClass('search-result-content')) {
			//update index of the loaded items in pagination only
			$('#shownresults').html($('.search-result-items:last').data('shownresults'));
			// hide ALL link if all products shown
			if ($('.search-result-items:last').data('shownresults') === $('.pagination .allresults').text()) {
				$('.pagination .display-all').hide();
			}
			//uniform apply to new products
			$('.search-result-items:last input[type=checkbox]').uniform();
		}

		lazyLoadInit(container.find('.load-more-link a'));
		wishlist.markWishlistProducts();
		// GTM linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			if ($('input[name=searchPhrase]').length <= 0) {
				linchpin.triggerCategoryLoadMore();
				// re-init add to compare event for newly loaded items
				linchpin.initAddToCompareEvent();
			}
		}
		if (SitePreferences.LAZYLOAD_ENABLED) {
			lazyloading.init(container);
		}
	}).fail(function () {
		//do nothing here;
	});
}

function loadBackToPageResult () {
	var isAlgoliaEnabled = window.algoliaData && window.algoliaData.enable && window.algoliaData.enablePLP;
	var $searchResults = isAlgoliaEnabled ? $('#algolia-hits-placeholder') : $('#search-result-items');
	var cgid = $searchResults.data('cgid');

	if (!User.lastProductID || !User.categoryReferer ||
			!cgid || User.categoryReferer !== cgid) {
		return;
	}

	var backPid = User.lastProductID;
	var $productTile = $('[data-itemid="' + backPid + '"]');
	if (!$productTile.length) {
		var $loadMore = isAlgoliaEnabled ? $('.algolia-load-more') : $('.load-more-link a');
		if ($loadMore.length > 0) {
			$loadMore.trigger('click');
		}
		return;
	}

	if ($productTile.length > 0 && typeof window.imagesLoaded !== 'undefined') {
		// eslint-disable-next-line no-undef
		imagesLoaded('.search-result-content').on('always', function () {
			$('html, body').scrollTop($productTile.offset().top);
		});
	}

}

function initHorizontalCarouselWrapper () {
	$('.horizontal-carousel-wrapper #horizontal-carousel').slick(util.sliderConfigs({instandard:5, inlarge:3, inmedium:2, insmall:1}));
}

function initAlgoliaProductTiles() {
	$(document).on('instantsearch:render', function() {
		if ($('.product-tile').not('.loaded').length > 0) {
			$('.product-tile').not('.loaded').each(function() {
				$(this).addClass('loaded');
			});
			productTile.init();
			wishlist.markWishlistProducts();
			if (SitePreferences.LAZYLOAD_ENABLED) {
				lazyloading.init($('.search-result-content'));
			}
			$(document).trigger('buildschema');
			// scroll to the last viewed product
			loadBackToPageResult();
		}
	});
}

function initMobileFilters () {
	var $mobileRefinements = $('#algolia-mobile-refinements');
	$(document).on('click', '.mobile-refinements-trigger', function () {
		$mobileRefinements.fadeIn();
		$('body').addClass('no-scroll');
	});
	$mobileRefinements.find('.js-close').on('click', function() {
		$mobileRefinements.fadeOut();
		$('body').removeClass('no-scroll');
	});
}

// Run schema only once when products loaded and then remove listner
var schemaLoaded = false;
$(document).on('buildschema', function (e) {
	e.preventDefault();

	if (schemaLoaded) {
		$(document).off('buildschema');
		return;
	}

	var $searchResultContent = $('.search-result-content');
	var productTiles = $searchResultContent.find('.product-tile.loaded');
	var productsIDs = [];
	productTiles.each(function (i, tile) {
		var pid = $(tile).data('pid');
		productsIDs.push(pid);
	});

	if (!productsIDs.length) {
		return;
	}

	var productsIDsStr = productsIDs.join('|');
	var URL = $('input[name=schemaurl]').val();
	URL = util.appendParamToURL(URL, 'productsIDs', productsIDsStr);
	$.getJSON(URL, function (structuredDataText) {

		if (schemaLoaded) {
			$(document).off('buildschema');
			return;
		}

		if (structuredDataText && typeof structuredDataText === 'object') {
			var script = document.createElement('script');
			script.setAttribute('type', 'application/ld+json');
			script.textContent = JSON.stringify(structuredDataText, null, 2);
			document.head.appendChild(script);

			schemaLoaded = true;
			$(document).off('buildschema');
		} else {
			console.warn('Error loading schema JSON-LD');
		}
	});
});

var search = {
	init: function (callback) {
		compareWidget.init();
		productTile.init();
		initializeEvents();
		initHorizontalCarouselWrapper();
		lazyLoadInit();
		refinementsSlider();
		// If a hash is given update the product grid with the new parameters
		if (window.location.hash) {
			updateProductListing();
		}
		if (SitePreferences.LAZYLOAD_ENABLED) {
			var container = $('#main');
			if ($('.search-load-in-primary').length > 0) {
				container = $('#primary');
			}
			lazyloading.init(container);
		}
		productTile.syncTilesHeightOnResize('.search-result-content');
		backtotop.init();
		if (window.algoliaData && window.algoliaData.enable && window.algoliaData.enablePLP) {
			initAlgoliaProductTiles();
			initMobileFilters();
		}
		this.callback = callback;
	},
	updateProductListing: updateProductListing
};

module.exports = search;
